// Admin version metadata. Surfaced in the Admin overview header
// badge so an operator triaging an issue can copy the exact build
// (version + git commit + Go runtime) into a support ticket without
// shelling into the pod. Admin-only — the public surface
// (`/api/public-config`) only exposes `version` + `build_time`.

import useSWR from 'swr';

export interface AdminVersion {
  version: string;       // ldflags-injected `git describe --tags --always --dirty`
  build_time: string;    // RFC3339 build timestamp; empty for dev builds
  built_at: string;      // alias of build_time, matches roadmap field name
  git_commit: string;    // short SHA the binary was built from; empty for dev builds
  go_version: string;    // runtime.Version() of the running binary
  runtime: string;       // always "go" for now
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

// The version doesn't change between page loads — disable revalidation
// so the badge tooltip is one round-trip per session.
export function useAdminVersion() {
  return useSWR<AdminVersion>('/api/admin/version', fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    dedupingInterval: 3_600_000,
  });
}
